// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__wLXEj","decoration":"styles_decoration__36qKs"};